/* FB QUICK ADD — laeg en stoerrelse i kurven direkte fra produktkortet.
   Ligger som delegeret listener paa document, saa kort der kommer ind
   senere (paginering, sektions-reload i editoren) virker uden ny binding. */
(function () {
  'use strict';

  /* Vagt mod dobbeltbinding. Scriptet maa kun hentes fra layout/theme.liquid. */
  if (window.__fbQuickAddInit) return;
  window.__fbQuickAddInit = true;

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function drawer() {
    var el = document.querySelector('cart-drawer');
    return el && typeof el.renderContents === 'function' ? el : null;
  }

  function setStatus(box, text) {
    var el = box && box.querySelector('[data-fb-qa-status]');
    if (el) el.textContent = text || '';
  }

  function addToCart(variantId, btn, box, opts) {
    var cd = drawer();
    var o = opts || {};
    var qty = Math.max(1, parseInt(o.quantity, 10) || 1);
    var body = { items: [{ id: Number(variantId), quantity: qty }] };

    /* Beder Shopify om at rendre kurv-sektionerne med i svaret, saa
       drawer'en kan opdatere sig selv i samme kald. */
    if (cd && typeof cd.getSectionsToRender === 'function') {
      body.sections = cd.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    btn.classList.add('is-busy');
    setStatus(box, '');

    fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        if (cd && data.sections) {
          cd.renderContents(data);
        } else if (cd && typeof cd.open === 'function') {
          cd.open();
        }
        return fetch(routeRoot() + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        /* fb-header.js lytter paa den her for at opdatere kurvtaelleren. */
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        var wrap = btn.closest('.fb-card-wrap');
        if (wrap) {
          wrap.classList.remove('is-qa-open');
          var t = wrap.querySelector('[data-fb-qa-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      })
      .catch(function (err) {
        setStatus(box, (err && (err.description || err.message)) || 'Could not add');
        /* Produktsiden har ingen statuslinje at skrive fejlen i. Der falder
           vi tilbage til et almindeligt form-submit, saa kunden stadig faar
           varen i kurven i stedet for at klikke paa en knap der ikke goer noget. */
        if (typeof o.onError === 'function') o.onError(err);
      })
      .then(function () {
        btn.classList.remove('is-busy');
      });
  }

  function closeCard(wrap) {
    if (!wrap) return;
    wrap.classList.remove('is-qa-open');
    var toggle = wrap.querySelector('[data-fb-qa-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function openCard(wrap) {
    /* Kun eet kort ad gangen, ellers staar der aabne stoerrelsesraekker
       spredt ud over hele gridet. */
    var open = document.querySelectorAll('.fb-card-wrap.is-qa-open');
    Array.prototype.forEach.call(open, function (el) {
      if (el !== wrap) closeCard(el);
    });
    wrap.classList.add('is-qa-open');
    var toggle = wrap.querySelector('[data-fb-qa-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    /* Kurv-knappen: folder stoerrelserne ud, laegger IKKE i kurven. */
    var toggle = target.closest('[data-fb-qa-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      var wrap = toggle.closest('.fb-card-wrap');
      if (!wrap) return;
      if (wrap.classList.contains('is-qa-open')) closeCard(wrap);
      else openCard(wrap);
      return;
    }

    /* En stoerrelse: her sker det rigtige. */
    var btn = target.closest('[data-fb-add]');
    var cardVariant = btn && btn.getAttribute('data-fb-add');
    /* Produktsidens koeb-knap baerer ogsaa data-fb-add, men UDEN variant-id,
       fordi den henter varianten fra formularens skjulte felt. Fangede vi den
       her, ville preventDefault draebe formularen og der ville blive postet
       id 0. Kun knapper med et rigtigt id hoerer til quick add. */
    if (btn && cardVariant && !btn.disabled) {
      /* Kortet er et link. Uden det her navigerer browseren i stedet. */
      event.preventDefault();
      event.stopPropagation();
      addToCart(cardVariant, btn, btn.closest('[data-fb-quickadd]'));
      return;
    }

    /* Klik udenfor et aabent kort lukker det igen. */
    if (!target.closest('.fb-card-wrap.is-qa-open')) {
      Array.prototype.forEach.call(
        document.querySelectorAll('.fb-card-wrap.is-qa-open'),
        closeCard
      );
    }
  });

  /* Produktsiden: laeg i kurv uden at forlade siden, saa drawer'en aabner
     ligesom paa kortene. Baade hovedknappen og den sticky knap paa mobil
     submitter den her formular. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form.fb-pdp__form')) return;
    if (form.dataset.fbNative === '1') return;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;

    var qtyInput = form.querySelector('[name="quantity"]');
    var btn = form.querySelector('[data-fb-add]') || form;

    event.preventDefault();
    addToCart(idInput.value, btn, null, {
      quantity: qtyInput && qtyInput.value,
      onError: function () {
        form.dataset.fbNative = '1';
        form.submit();
      },
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    Array.prototype.forEach.call(
      document.querySelectorAll('.fb-card-wrap.is-qa-open'),
      closeCard
    );
  });
})();

